// extracted by mini-css-extract-plugin
export var button = "_lr-0";
export var donut = "_lr-1";
export var donutFill = "_lr-3";
export var donutTrack = "_lr-2";